import { translate } from '~/scripts/locales/translations';
import axios from 'axios';

export default function entriesTranslation(googleTranslateApiKey, source) {
  return {
    isTranslated: false,
    translationSaved: false,
    error: false,
    currentLocale: document.querySelector('html').getAttribute('lang'),
    translateControl: document.querySelector('.entry-detail__translate'),
    translateText: null,
    toTranslationMessage: null,
    translatedBy: null,
    translateError: null,
    entryFields: null,

    init() {
      if (!this.translateControl) return;

      this.translateText = this.translateControl.querySelector('.entry-detail__translate-text');
      this.toTranslationMessage = this.translateText.textContent;
      this.translatedBy = this.translateControl.querySelector('.entry-detail__translated-by');
      this.translateError = this.translateControl.querySelector('.entry-detail__translate-error');
      this.translateControl.querySelector('.entry-detail__translate-icon').classList.remove('hidden');

      this.setTranslationButtonText();
      this.entryFields = this.createEntryFields();

      // save the original text in localStorage
      this.entryFields.forEach((field, index) => localStorage.setItem(index, field.innerHTML));

      this.translateText.addEventListener('click', () => {
        this.handleTranslate();
      });
    },

    setTranslationButtonText() {
      // use translate to get the different messages in the correct language
      const backToOriginalMessage = translate('entry-translation', 'show_original', this.currentLocale);
      const translationByMessage = translate('entry-translation', 'translated_by_google', this.currentLocale);
      const errorMessage = translate('entry-translation', 'error', this.currentLocale);

      if (this.isTranslated) {
        this.translateText.innerText = backToOriginalMessage;
        this.translatedBy.innerText = translationByMessage;
      } else {
        this.translateText.innerText = this.toTranslationMessage;
        this.translatedBy.innerText = '';
      }
      if (this.error) {
        this.translateError.innerText = errorMessage;
      }
    },

    // creates an array with all DOM nodes inside
    createEntryFields() {
      return [...this.$refs.entry.querySelectorAll("[data-id='title'], [data-field-type]")];
    },

    handleTranslate() {
      if (this.isTranslated) {
        // restore original text in DOM from localStorage
        this.entryFields.forEach((field, index) => (field.innerHTML = localStorage.getItem(index)));
        this.isTranslated = false;
      } else if (this.translationSaved) {
        // restore translations in DOM from localStorage
        this.entryFields.forEach((field, index) => (field.innerHTML = localStorage.getItem(`translated-${index}`)));
        this.isTranslated = true;
      } else {
        // get translations from google
        this.fetchGoogleTranslation();
        this.isTranslated = true;
        this.translationSaved = true;
      }
      this.setTranslationButtonText();
    },

    async fetchGoogleTranslation() {
      axios
        .post(`https://translation.googleapis.com/language/translate/v2?key=${googleTranslateApiKey}`, {
          q: this.entryFields.map((text) => text.innerHTML),
          source: source,
          target: this.currentLocale,
          format: 'html',
        })
        .then((response) => {
          const googleTranslations = response.data.data.translations;
          googleTranslations.forEach((translation, index) => {
            // update the DOM with the translated text by changing the DOM nodes in entryFields
            this.entryFields[index].innerHTML = translation.translatedText;

            // save the translated text in localStorage
            localStorage.setItem(`translated-${index}`, translation.translatedText);
          });

          this.error = false;
        })
        .catch(() => {
          this.error = true;
        });
    },
  };
}
